import { useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ReachedOutImage1 from '../../assets/reach-out-image-1.png'
import ReachedOutImage2 from '../../assets/reach-out-image-2.png'
import ReachedOutImage3 from '../../assets/reach-out-image-3.png'
import ReachedOutImage4 from '../../assets/reach-out-image-4.png'
import sendMessageImage from '../../assets/send-message-image.png'
import GetTouchImage1 from '../../assets/get-touch-image-1.png'
import GetTouchImage2 from '../../assets/get-touch-image-2.png'
import GetTouchImage3 from '../../assets/get-touch-image-3.png'
import GetTouchImage4 from '../../assets/get-touch-image-4.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'

import './Contactus.css'

function Contactus() {
    const [activeView, setActiveView] = useState('contact');
    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };

    return (
        <>
            <Navbar />

            <div className="contact-us-main-container">
                <h1 className="contact-us-heading">Contact Us</h1>
                <p className="contact-us-description">Whether you're a restaurant, retailer, or hotelier — our team is ready to guide you with the right POS solution.</p>
                <button className="contact-us-button">Talk to Our Experts</button>
            </div>

            <div className="reach-out-main-container">
                <h1 className="reach-out-heading">Why Reach Out to Us?</h1>
                <p className="reach-out-description">Experience the difference with our premium support</p>

                <div className="reach-out-cards">
                    <div className="reach-out-cards-container">
                        <img src={ReachedOutImage1} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">24/7 Dedicated Support</h1>
                        <p className="reach-out-image-description">Round-the-clock assistance whenever you need it</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={ReachedOutImage2} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Free Demo & Enquiries</h1>
                        <p className="reach-out-image-description">See our POS system in action before you decide</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={ReachedOutImage3} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Tailored POS Solutions</h1>
                        <p className="reach-out-image-description">Customized to fit your specific business needs</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={ReachedOutImage4} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Transparent Pricing</h1>
                        <p className="reach-out-image-description">No hidden fees, clear pricing structure</p>
                    </div>
                </div>
            </div>

            <div className="contact-form-main-container-about">
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a product</option>
                                        <option value="Fleet Eats">Fleet Eats</option>
                                        <option value="Fleet Mart">Fleet Mart</option>
                                        <option value="Fleet Stay">Fleet Stay</option>
                                        <option value="Fleet Office">Fleet Office</option>
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background-home">
                            <div className="reach-out-cards-container">
                                <img src={GetTouchImage4} alt="reach-out-image" className="reach-out-image" />
                                <h1 className="touch-image-heading">SassyMonks Private Limited</h1>
                                <p className="touch-image-description">Headquarters Location</p>
                                <button className="get-direct-button">Get Directions</button>
                            </div>
                        </div>
                    )}

                </div>
            </div>

            <div className="reach-out-main-container">
                <h1 className="reach-out-heading">Get in Touch</h1>

                <div className="reach-out-cards">
                    <div className="reach-out-cards-container">
                        <img src={GetTouchImage1} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Email Support</h1>
                        <p className="reach-out-image-description-touch">sales@fleetorder.in</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={GetTouchImage2} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Phone Support</h1>
                        <p className="reach-out-image-description-touch">+91-73866 16587</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={GetTouchImage3} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">WhatsApp Chat</h1>
                        <p className="reach-out-image-description-touch">Instant Query Resolution</p>
                    </div>

                    <div className="reach-out-cards-container">
                        <img src={GetTouchImage4} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="reach-out-image-heading">Office Address</h1>
                        <p className="reach-out-image-description-touch">Thub Phase 2, 20, Inorbit Mall Rd, Vittal Rao Nagar, Madhapur, Hyderabad, Telangana 500081</p>
                    </div>
                </div>
            </div>

            <div className="reach-out-main-container-main">
                <h1 className="reach-out-heading">Visit Our Office</h1>
                <p className="reach-out-description">Come meet our team in person</p>
                {/* <div className="reach-out-cards-container">
                        <img src={GetTouchImage4} alt="reach-out-image" className="reach-out-image" />
                        <h1 className="touch-image-heading">SassyMonks Private Limited</h1>
                        <p className="touch-image-description">Headquarters Location</p>
                        <button className="get-direct-button">Get Directions</button>
                    </div> */}

                <div className="map-image-background">
                    <div className="reach-out-cards-container">
                       <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                    </div>
                </div>

            </div>

            {/* <a
                href="https://api.whatsapp.com/send?phone=+917386616587&text=Hey,+I+am+interested+in+FleetOrder+POS+with+contactless+dining+software.+I+am+looking+for+the+demo%21&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-float"
            >
                <img src={whatsappIcon} alt="Chat on WhatsApp" className="whatsapp-icon" />
            </a> */}
            <Footer />
        </>
    )
}

export default Contactus